import { render, staticRenderFns } from "./Emp_new.vue?vue&type=template&id=6c59e7a8&scoped=true"
import script from "./Emp_new.vue?vue&type=script&lang=js"
export * from "./Emp_new.vue?vue&type=script&lang=js"
import style0 from "./Emp_new.vue?vue&type=style&index=0&id=6c59e7a8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c59e7a8",
  null
  
)

export default component.exports